import { ApiStatus } from "src/config/enums/genericEnums";
import { GlobalAlertsInitialState } from "src/components/HeaderLink/interface";
import { getFirstDefined } from "src/utils/genericFunctions";

export const initialState: GlobalAlertsInitialState = {
  readToken: "",
  writeToken: "",
  dismissAlerts: {
    status: "idle"
  },
  globalAlertsData: {
    status: "idle",
    data: [],
    error: "",
    triggerCount: 0
  }
};

export const handlePendingFetchGlobalAlertsData = (
  state: GlobalAlertsInitialState
) => {
  state.globalAlertsData.status = ApiStatus.PENDING;
};

export const handleFulfillFetchGlobalAlertsData = (
  state: GlobalAlertsInitialState,
  { payload }: any
) => {
  state.globalAlertsData = {
    data: getFirstDefined(payload.data, []),
    status: ApiStatus.IDLE,
    error: "",
    triggerCount: state.globalAlertsData.triggerCount + 1
  };
};

export const handleFailFetchGlobalAlertsData = (
  state: GlobalAlertsInitialState
) => {
  state.globalAlertsData.status = ApiStatus.ERROR;
};

export const handleFulFillFetchFirebaseToken = (
  state: GlobalAlertsInitialState,
  { payload }: any
) => {
  state.readToken = payload.data;
};

export const handlePendingFetchFirebaseToken = (
  state: GlobalAlertsInitialState
) => {
  state.readToken = null;
};

export const handlePendingDismissAllAlerts = (
  state: GlobalAlertsInitialState
) => {
  state.dismissAlerts.status = ApiStatus.PENDING;
};

export const handleFulfillDismissAllAlerts = (
  state: GlobalAlertsInitialState
) => {
  state.dismissAlerts.status = ApiStatus.IDLE;
  state.globalAlertsData.data = [];
};

export const handleFailDismissAllAlerts = (state: GlobalAlertsInitialState) => {
  state.dismissAlerts.status = ApiStatus.ERROR;
};

export const handleResetAlerts = () => initialState;
